import * as React from 'react'
import { Icon } from '../../atoms/icon'
import { Size, Color } from '../../../constants/app.constant'

interface Props {
  evaluation: number
}

export default (props: Props) => (
  <>
    {(() => {
      if (props.evaluation === 100) {
        return (
          <Icon.Status4
            size={`${Size.LARGE}px`}
            color={Color.STATUS_COLOR.STATUS_4}
          />
        )
      } else if (props.evaluation >= 75) {
        return (
          <Icon.Status3
            size={`${Size.LARGE}px`}
            color={Color.STATUS_COLOR.STATUS_3}
          />
        )
      } else if (props.evaluation >= 50) {
        return (
          <Icon.Status2
            size={`${Size.LARGE}px`}
            color={Color.STATUS_COLOR.STATUS_2}
          />
        )
      } else if (props.evaluation >= 25) {
        return (
          <Icon.Status1
            size={`${Size.LARGE}px`}
            color={Color.STATUS_COLOR.STATUS_1}
          />
        )
      } else {
        return (
          <Icon.Status0
            size={`${Size.LARGE}px`}
            color={Color.STATUS_COLOR.STATUS_0}
          />
        )
      }
    })()}
  </>
)



// WEBPACK FOOTER //
// ./src/components/molecules/total-status-icon/total-status-icon.tsx